module.exports = __webpack_public_path__ + "media/images/favicons/favicon-friday-86d78ff07d45458d17051a1c40aa6f9d.ico";